export const NOTE_SCOPE = 'NOTE';
export const WORK_SESSION_NOTE_SOURCE = 'WORK_SESSION';
export const SESSIONS_FOLDER_NAME = 'Sessions';
